import React from "react";
import { Eye, CircleAlert, CircleDollarSign } from "lucide-react";
import { Button } from "components/ui/button";

const cardHoverClass =
  "bg-white p-5 rounded-2xl border border-[#E8DDD3] shadow-sm " +
  "transition-all duration-300 ease-in-out " +
  "hover:border-[#e8d0aa] hover:shadow-[5px_5px_0px_0px_#e8d0aa] hover:-translate-y-1 " +
  "hover:scale-[1.00] cursor-pointer relative overflow-hidden";

const StatusBadge = ({ isAvailable }) => {
  const statusText = isAvailable ? "Available" : "On Rent";

  const styles = {
    Available: "bg-green-50 text-green-600 border border-green-100",
    "On Rent": "bg-orange-100 text-orange-500 border border-orange-100",
    "Under Maintenance": "bg-red-100 text-red-600 border border-red-100",
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap flex-shrink-0 ${styles[statusText] || styles["On Rent"]}`}>
      <CircleAlert className="w-2.5 h-2.5 flex-shrink-0" />
      <span>{statusText}</span>
    </span>
  );
};

const EquipmentRentCard = ({ item, handleOpenEquipmentDetails }) => {
  // Destructure for cleaner code, using optional chaining
  const equipment = item?.equipment || {};

  return (
    <div className={`${cardHoverClass} bg-gradient-to-b from-[#E7DDD4] to-[#FFFFFF] bg-no-repeat bg-cover relative overflow-hidden`}>
      <div className="relative overflow-hidden group h-[196px] bg-[#E7DDD4]">
        <span className="absolute top-3 left-3 bg-white text-black text-sm font-medium px-3 py-1 rounded-full shadow-sm z-20">
          {equipment.category || "General"}
        </span>

        <img
          src={equipment.imgSrc || "/images/misc/equipment_1.png"}
          alt={equipment.equipment_name}
          className="mx-auto h-full w-full object-contain transition-transform duration-300 ease-out group-hover:scale-110 relative z-10"
        />
      </div>

      <div className="px-6 py-2 bg-white">
        <div className="flex items-start justify-between gap-6">
          <h3 className="font-semibold text-base leading-6 truncate w-2/3">
            {equipment.equipment_name || "Unknown Gear"}
          </h3>
          <StatusBadge isAvailable={item?.is_available_for_rent} />
        </div>

        <p className="text-sm text-[#737373] mt-1 leading-5 truncate min-w-0">
          {equipment.description || "No description available"}
        </p>

        <div className="mt-2 text-sm font-medium text-[#1F2937]">
          <span className="block">Rental Rate: ${item?.rental_price || "0"} / day</span>
        </div>
      </div>

      <div className="px-6 py-4 border-t border-[#F5EBDA] flex items-center justify-between bg-white">
        <div className="flex items-center gap-2 font-medium text-xs">
          <CircleDollarSign className="w-4 h-4" />
          <span>${item?.rental_price || "0"}</span>
        </div>

        <div className="flex gap-2">
          <button
            onClick={() => handleOpenEquipmentDetails(equipment.equipment_id)}
            className="w-9 h-9 rounded-lg bg-[#F5F5F5] flex items-center justify-center shadow hover:bg-[#262626] group transition-colors"
          >
            <Eye className="w-4 h-4 group-hover:text-white" />
          </button>

          <Button className="bg-gray-900 text-white hover:bg-gray-800 rounded-lg px-4 h-9 text-sm">
            Rent
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EquipmentRentCard;
